import api from "./apiWithAccessToken"; 

export const saveSmtpConfig = (data) => api.post("smtp-config", data);

export const getSmtpConfig = () => api.get("/smtp-config");

export const sendTestEmail = (data) => {
  const url = process.env.REACT_APP_WELCOME_URL;
  const payload = { ...data, url };
  return api.post("/send-welcome-email", payload);
};
